export const ModalChangeEmailTranslationsUk = {
  changeEmailMessage:
    'Повідомлення для підтвердження зміни електронної пошти відправлено на {{email}}. Будь ласка, перевірте вашу поштову скриньку та слідуйте інструкціям для підтвердження.',
  changeEmailTitle: 'Змінити пошту',
  enterEmailLabel: 'Введіть адресу електронної пошти',
  emailPlaceholder: 'example@gmail.com',
  'Email in use': 'Упс, ця пошта вже зайнята!',
  saveButton: 'Зберегти',
};
